import { Component, OnInit, ViewChild } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "../../Services/crud.service";
import { Router } from "@angular/router";
// import { ReCaptchaV3Service } from "ng-recaptcha";
import { FormStateService } from "src/app/Services/form.service";
import { RecaptchaService } from "src/app/Services/recaptcha.service";
declare const grecaptcha: any;
@Component({
  selector: "app-company-registration",
  templateUrl: "./company-registration.component.html",
  standalone: false,
})
export class CompanyRegistrationComponent implements OnInit {
  @ViewChild("phone_id") phoneInput: any;
  registerForm: UntypedFormGroup;
  submitted = false;
  currentDateTime: any;
  country;
  initialCountry;
  timeZone: any;
  countryCode: any;
  initialCountryCode: string = "in";
  loading;
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private router: Router,
    private recaptcha: RecaptchaService,
    // private recaptchaV3Service: ReCaptchaV3Service,
    private formStateService: FormStateService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }
  captchaToken: string | null = null;
  ngOnInit() {
    // console.log("country code", Object.keys(this.countryCode));
    this.registerForm = this.formBuilder.group({
      name: [
        "",
        [Validators.required, this.noOnlySpaces(), this.noOnlySpecialChars()],
      ],
      contactPerson: [
        "",
        [Validators.required, this.noOnlySpaces(), this.noOnlySpecialChars()],
      ],
      emailId: [
        "",
        [Validators.required, Validators.email, this.dotInUsernameValidator()],
      ],

      password: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/
          ),
        ],
      ],
      confirmPassword: ["", [Validators.required, this.passwordValidator()]],
      phone: ["", [Validators.pattern("^[0-9]*$")]],
    });

    this.registerForm.get("phone").valueChanges.subscribe((value) => {
      const newValue = value.replace(/\s/g, "");
      this.registerForm.get("phone").setValue(newValue, { emitEvent: false });
    });

    this.registerForm.valueChanges.subscribe(() => {
      if (this.registerForm.dirty) {
        this.formStateService.setFormDirty();
      }
    });
    this.setPhoneCode();
  }
  setPhoneCode(): void {
    this.timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.country = this.getCountryFromTimeZone(this.timeZone);

    this.countryCode = countryCodes[this.country];

    if (this.country) {
      this.initialCountryCode = countryCodes[this.country]["countryCode"];
    }
  }
  /*   ngAfterViewInit() {
    const phoneInputInstance = this.phoneInput.nativeElement;
    const intlTelInput = window.intlTelInput(phoneInputInstance, {
      initialCountry: "in",
      preferredCountries: ["in", "us"],
      separateDialCode: true,
    });

    this.setPhoneCode();
  } */
  dotInUsernameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const hasDot = control.value ? control.value.includes(".") : false;
      return hasDot ? null : { noDotInUsername: true };
    };
  }
  noOnlySpaces(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value === null || value === "") {
        return null; // don't flag empty fields
      }

      const isWhitespace = value.trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }
  noOnlySpecialChars(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;

      if (value === null || value.trim() === "") {
        return null; // Allow empty values — handled by Validators.required if needed
      }

      // Check if the value contains at least one alphanumeric character
      const hasAlphanumeric = /[a-zA-Z0-9]/.test(value);
      return hasAlphanumeric ? null : { onlySpecialChars: true };
    };
  }
  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent;

      if (!formGroup) {
        return null;
      }

      const password = formGroup.get("password").value;
      const confirmPassword = formGroup.get("confirmPassword").value;

      let match = false;

      match = password !== confirmPassword;

      if (match) {
        return { match: true };
      }

      return null;
    };
  }

  get f() {
    return this.registerForm.controls;
  }

  onSubmit(url: string) {
    this.submitted = true;

    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    /*   this.recaptchaV3Service
      .execute("importantAction")
      .subscribe((token: string) => {
        // console.log(`Token [${token}] generated`);
      }); */
    var self = this;

    var payload = self.registerForm.value;
    payload["status"] = "Enabled";
    this.loading = true;
    this.recaptcha
      .executeAction("companyRegistrations")
      .then((token) => {
        // Verify token (optional: only if you have backend verification)
        this.recaptcha
          .verifyToken(token, "companyRegistrations", payload)
          .subscribe((response) => {
            var isSuccess = response.result ?? "";

            if (isSuccess.message && isSuccess.message == "verified") {
              self.crudService.post(
                payload,
                function (response) {
                  if (response) {
                    if (
                      response.error &&
                      response.error.error &&
                      response.error.error.message
                    ) {
                      if (response.error.error.message == "INVALID_PASSWORD") {
                        self.toastr.error(
                          "Password must contain at least 8 characters, including uppercase, lowercase, number, and special character.",
                          "Invalid password"
                        );
                      }
                      self.toastr.error(
                        response.error.error.message,
                        "Invalid Operation"
                      );
                    } else {
                      self.toastr.success(
                        "Company has been registered successfully.",
                        "Success"
                      );
                      self.formStateService.clearFormDirty();
                      self.router.navigate(["thankyou-page", "registration"]);
                    }
                  } else {
                    self.toastr.error("Invalid Credentials");
                  }
                },
                "companyRegistrations"
              );
            } else if (
              isSuccess.message &&
              isSuccess.message == "bot-like-behavior"
            ) {
              self.toastr.error(
                "Please try again later or use a different browser."
              );
            } else {
              self.toastr.error("reCAPTCHA failed. Please try again.");
            }
          });
      })
      .catch((err) => {
        console.error("reCAPTCHA error:", err);
        self.toastr.error("reCAPTCHA validation error. Try again later.");
      });
  }

  onReset() {
    this.submitted = false;
    this.registerForm.reset();
    this.formStateService.clearFormDirty();
  }
  getCountryFromTimeZone(timezone: string): string {
    var countries = {
      "Africa/Abidjan": "Ivory Coast",
      "Africa/Accra": "Ghana",
      "Africa/Addis_Ababa": "Ethiopia",
      "Africa/Algiers": "Algeria",
      "Africa/Asmara": "Eritrea",
      "Africa/Bamako": "Mali",
      "Africa/Banjul": "Gambia",
      "Africa/Bujumbura": "Burundi",
      "Africa/Cairo": "Egypt",
      "Africa/Casablanca": "Morocco",
      "Africa/Ceuta": "Spain",
      "Africa/Conakry": "Guinea",
      "Africa/Dakar": "Senegal",
      "Africa/Dar_es_Salaam": "Tanzania",
      "Africa/Johannesburg": "South Africa",
      "Africa/Juba": "South Sudan",
      "Africa/Kampala": "Uganda",
      "Africa/Lagos": "Nigeria",
      "Africa/Libreville": "Gabon",
      "Africa/Luanda": "Angola",
      "Africa/Malabo": "Equatorial Guinea",
      "Africa/Maputo": "Mozambique",
      "Africa/Maseru": "Lesotho",
      "Africa/Mbabane": "Eswatini",
      "Africa/Mogadishu": "Somalia",
      "Africa/Nairobi": "Kenya",
      "Africa/Ndjamena": "Chad",
      "Africa/Porto-Novo": "Benin",
      "Africa/Sao_Tome": "São Tomé and Príncipe",
      "Africa/Tunis": "Tunisia",
      "Africa/Windhoek": "Namibia",
      "America/Adak": "United States",
      "America/Anchorage": "United States",
      "America/Argentina/Buenos_Aires": "Argentina",
      "America/Chicago": "United States",
      "America/Los_Angeles": "United States",
      "America/New_York": "United States",
      "America/Phoenix": "United States",
      "America/Sao_Paulo": "Brazil",
      "Asia/Almaty": "Kazakhstan",
      "Asia/Amman": "Jordan",
      "Asia/Baghdad": "Iraq",
      "Asia/Baku": "Azerbaijan",
      "Asia/Bangkok": "Thailand",
      "Asia/Beirut": "Lebanon",
      "Asia/Calcutta": "India",
      "Asia/Dhaka": "Bangladesh",
      "Asia/Dubai": "United Arab Emirates",
      "Asia/Hong_Kong": "Hong Kong",
      "Asia/Jakarta": "Indonesia",
      "Asia/Jerusalem": "Israel",
      "Asia/Kathmandu": "Nepal",
      "Asia/Kolkata": "India",
      "Asia/Kuala_Lumpur": "Malaysia",
      "Asia/Kuwait": "Kuwait",
      "Asia/Macau": "Macau",
      "Asia/Manila": "Philippines",
      "Asia/Shanghai": "China",
      "Asia/Singapore": "Singapore",
      "Asia/Taipei": "Taiwan",
      "Asia/Tashkent": "Uzbekistan",
      "Asia/Tbilisi": "Georgia",
      "Asia/Tehran": "Iran",
      "Asia/Tokyo": "Japan",
      "Asia/Ulaanbaatar": "Mongolia",
      "Asia/Yerevan": "Armenia",
      "Australia/Adelaide": "Australia",
      "Australia/Brisbane": "Australia",
      "Australia/Darwin": "Australia",
      "Australia/Hobart": "Australia",
      "Australia/Melbourne": "Australia",
      "Australia/Sydney": "Australia",
      "Europe/Amsterdam": "Netherlands",
      "Europe/Athens": "Greece",
      "Europe/Belgrade": "Serbia",
      "Europe/Berlin": "Germany",
      "Europe/Brussels": "Belgium",
      "Europe/Bucharest": "Romania",
      "Europe/Budapest": "Hungary",
      "Europe/Chisinau": "Moldova",
      "Europe/Copenhagen": "Denmark",
      "Europe/Dublin": "Ireland",
      "Europe/Helsinki": "Finland",
      "Europe/Istanbul": "Turkey",
      "Europe/Kiev": "Ukraine",
      "Europe/Lisbon": "Portugal",
      "Europe/London": "United Kingdom",
      "Europe/Luxembourg": "Luxembourg",
      "Europe/Madrid": "Spain",
      "Europe/Minsk": "Belarus",
      "Europe/Monaco": "Monaco",
      "Europe/Moscow": "Russia",
      "Europe/Oslo": "Norway",
      "Europe/Paris": "France",
      "Europe/Prague": "Czech Republic",
      "Europe/Rome": "Italy",
      "Europe/Sofia": "Bulgaria",
      "Europe/Stockholm": "Sweden",
      "Europe/Tallinn": "Estonia",
      "Europe/Tirane": "Albania",
      "Europe/Vienna": "Austria",
      "Europe/Warsaw": "Poland",
      "Europe/Zagreb": "Croatia",
      "Indian/Antananarivo": "Madagascar",
      "Indian/Maldives": "Maldives",
      "Indian/Mauritius": "Mauritius",
      "Indian/Reunion": "Réunion",
      "Pacific/Auckland": "New Zealand",
      "Pacific/Fiji": "Fiji",
      "Pacific/Guam": "Guam",
      "Pacific/Honolulu": "United States",
      "Pacific/Majuro": "Marshall Islands",
      "Pacific/Noumea": "New Caledonia",
      "Pacific/Port_Moresby": "Papua New Guinea",
      "Pacific/Tongatapu": "Tonga",
      "Pacific/Wellington": "New Zealand",
      UTC: "Coordinated Universal Time",
    };
    return countries[timezone] || "Unknown";
  }
}

var countryCodes = {
  Afghanistan: { countryCode: "AF", phoneCode: "+93" },
  Albania: { countryCode: "AL", phoneCode: "+355" },
  Algeria: { countryCode: "DZ", phoneCode: "+213" },
  "American Samoa": { countryCode: "AS", phoneCode: "+1684" },
  Andorra: { countryCode: "AD", phoneCode: "+376" },
  Angola: { countryCode: "AO", phoneCode: "+244" },
  Anguilla: { countryCode: "AI", phoneCode: "+1264" },
  "Antigua and Barbuda": { countryCode: "AG", phoneCode: "+1268" },
  Argentina: { countryCode: "AR", phoneCode: "+54" },
  Armenia: { countryCode: "AM", phoneCode: "+374" },
  Aruba: { countryCode: "AW", phoneCode: "+297" },
  Australia: { countryCode: "AU", phoneCode: "+61" },
  Austria: { countryCode: "AT", phoneCode: "+43" },
  Azerbaijan: { countryCode: "AZ", phoneCode: "+994" },
  Bahamas: { countryCode: "BS", phoneCode: "+1242" },
  Bahrain: { countryCode: "BH", phoneCode: "+973" },
  Bangladesh: { countryCode: "BD", phoneCode: "+880" },
  Barbados: { countryCode: "BB", phoneCode: "+1246" },
  Belarus: { countryCode: "BY", phoneCode: "+375" },
  Belgium: { countryCode: "BE", phoneCode: "+32" },
  Belize: { countryCode: "BZ", phoneCode: "+501" },
  Benin: { countryCode: "BJ", phoneCode: "+229" },
  Bhutan: { countryCode: "BT", phoneCode: "+975" },
  Bolivia: { countryCode: "BO", phoneCode: "+591" },
  "Bosnia and Herzegovina": { countryCode: "BA", phoneCode: "+387" },
  Botswana: { countryCode: "BW", phoneCode: "+267" },
  Brazil: { countryCode: "BR", phoneCode: "+55" },
  Brunei: { countryCode: "BN", phoneCode: "+673" },
  Bulgaria: { countryCode: "BG", phoneCode: "+359" },
  "Burkina Faso": { countryCode: "BF", phoneCode: "+226" },
  Burundi: { countryCode: "BI", phoneCode: "+257" },
  Cambodia: { countryCode: "KH", phoneCode: "+855" },
  Cameroon: { countryCode: "CM", phoneCode: "+237" },
  Canada: { countryCode: "CA", phoneCode: "+1" },
  "Cape Verde": { countryCode: "CV", phoneCode: "+238" },
  "Cayman Islands": { countryCode: "KY", phoneCode: "+1345" },
  "Central African Republic": { countryCode: "CF", phoneCode: "+236" },
  Chad: { countryCode: "TD", phoneCode: "+235" },
  Chile: { countryCode: "CL", phoneCode: "+56" },
  China: { countryCode: "CN", phoneCode: "+86" },
  "Christmas Island": { countryCode: "CX", phoneCode: "+61" },
  "Cocos (Keeling) Islands": { countryCode: "CC", phoneCode: "+61" },
  Colombia: { countryCode: "CO", phoneCode: "+57" },
  Comoros: { countryCode: "KM", phoneCode: "+269" },
  "Congo (Republic of the)": { countryCode: "CG", phoneCode: "+242" },
  "Congo (Democratic Republic of the)": {
    countryCode: "CD",
    phoneCode: "+243",
  },
  "Cook Islands": { countryCode: "CK", phoneCode: "+682" },
  "Costa Rica": { countryCode: "CR", phoneCode: "+506" },
  Croatia: { countryCode: "HR", phoneCode: "+385" },
  Cuba: { countryCode: "CU", phoneCode: "+53" },
  Curaçao: { countryCode: "CW", phoneCode: "+599" },
  Cyprus: { countryCode: "CY", phoneCode: "+357" },
  "Czech Republic": { countryCode: "CZ", phoneCode: "+420" },
  Denmark: { countryCode: "DK", phoneCode: "+45" },
  Djibouti: { countryCode: "DJ", phoneCode: "+253" },
  Dominica: { countryCode: "DM", phoneCode: "+1767" },
  "Dominican Republic": { countryCode: "DO", phoneCode: "+1809" },
  Ecuador: { countryCode: "EC", phoneCode: "+593" },
  Egypt: { countryCode: "EG", phoneCode: "+20" },
  "El Salvador": { countryCode: "SV", phoneCode: "+503" },
  "Equatorial Guinea": { countryCode: "GQ", phoneCode: "+240" },
  Eritrea: { countryCode: "ER", phoneCode: "+291" },
  Estonia: { countryCode: "EE", phoneCode: "+372" },
  Ethiopia: { countryCode: "ET", phoneCode: "+251" },
  "Falkland Islands": { countryCode: "FK", phoneCode: "+500" },
  "Faroe Islands": { countryCode: "FO", phoneCode: "+298" },
  Fiji: { countryCode: "FJ", phoneCode: "+679" },
  Finland: { countryCode: "FI", phoneCode: "+358" },
  France: { countryCode: "FR", phoneCode: "+33" },
  "French Guiana": { countryCode: "GF", phoneCode: "+594" },
  "French Polynesia": { countryCode: "PF", phoneCode: "+689" },
  "French Southern and Antarctic Lands": {
    countryCode: "TF",
    phoneCode: "+262",
  },
  Gabon: { countryCode: "GA", phoneCode: "+241" },
  Gambia: { countryCode: "GM", phoneCode: "+220" },
  Georgia: { countryCode: "GE", phoneCode: "+995" },
  Germany: { countryCode: "DE", phoneCode: "+49" },
  Ghana: { countryCode: "GH", phoneCode: "+233" },
  Gibraltar: { countryCode: "GI", phoneCode: "+350" },
  Greece: { countryCode: "GR", phoneCode: "+30" },
  Greenland: { countryCode: "GL", phoneCode: "+299" },
  Grenada: { countryCode: "GD", phoneCode: "+1473" },
  Guadeloupe: { countryCode: "GP", phoneCode: "+590" },
  Guam: { countryCode: "GU", phoneCode: "+1671" },
  Guatemala: { countryCode: "GT", phoneCode: "+502" },
  Guernsey: { countryCode: "GG", phoneCode: "+44" },
  Guinea: { countryCode: "GN", phoneCode: "+224" },
  "Guinea-Bissau": { countryCode: "GW", phoneCode: "+245" },
  Guyana: { countryCode: "GY", phoneCode: "+592" },
  Haiti: { countryCode: "HT", phoneCode: "+509" },
  "Heard Island and McDonald Islands": { countryCode: "HM", phoneCode: "+61" },
  Honduras: { countryCode: "HN", phoneCode: "+504" },
  "Hong Kong": { countryCode: "HK", phoneCode: "+852" },
  Hungary: { countryCode: "HU", phoneCode: "+36" },
  Iceland: { countryCode: "IS", phoneCode: "+354" },
  India: { countryCode: "IN", phoneCode: "+91" },
  Indonesia: { countryCode: "ID", phoneCode: "+62" },
  Iran: { countryCode: "IR", phoneCode: "+98" },
  Iraq: { countryCode: "IQ", phoneCode: "+964" },
  Ireland: { countryCode: "IE", phoneCode: "+353" },
  Israel: { countryCode: "IL", phoneCode: "+972" },
  Italy: { countryCode: "IT", phoneCode: "+39" },
  Jamaica: { countryCode: "JM", phoneCode: "+1" },
  Japan: { countryCode: "JP", phoneCode: "+81" },
  Jersey: { countryCode: "JE", phoneCode: "+44" },
  Jordan: { countryCode: "JO", phoneCode: "+962" },
  Kazakhstan: { countryCode: "KZ", phoneCode: "+7" },
  Kenya: { countryCode: "KE", phoneCode: "+254" },
  Kiribati: { countryCode: "KI", phoneCode: "+686" },
  Kuwait: { countryCode: "KW", phoneCode: "+965" },
  Kyrgyzstan: { countryCode: "KG", phoneCode: "+996" },
  Laos: { countryCode: "LA", phoneCode: "+856" },
  Latvia: { countryCode: "LV", phoneCode: "+371" },
  Lebanon: { countryCode: "LB", phoneCode: "+961" },
  Lesotho: { countryCode: "LS", phoneCode: "+266" },
  Liberia: { countryCode: "LR", phoneCode: "+231" },
  Libya: { countryCode: "LY", phoneCode: "+218" },
  Liechtenstein: { countryCode: "LI", phoneCode: "+423" },
  Lithuania: { countryCode: "LT", phoneCode: "+370" },
  Luxembourg: { countryCode: "LU", phoneCode: "+352" },
  Macau: { countryCode: "MO", phoneCode: "+853" },
  Macedonia: { countryCode: "MK", phoneCode: "+389" },
  Madagascar: { countryCode: "MG", phoneCode: "+261" },
  Malawi: { countryCode: "MW", phoneCode: "+265" },
  Malaysia: { countryCode: "MY", phoneCode: "+60" },
  Maldives: { countryCode: "MV", phoneCode: "+960" },
  Mali: { countryCode: "ML", phoneCode: "+223" },
  Malta: { countryCode: "MT", phoneCode: "+356" },
  "Marshall Islands": { countryCode: "MH", phoneCode: "+692" },
  Martinique: { countryCode: "MQ", phoneCode: "+596" },
  Mauritania: { countryCode: "MR", phoneCode: "+222" },
  Mauritius: { countryCode: "MU", phoneCode: "+230" },
  Mayotte: { countryCode: "YT", phoneCode: "+262" },
  Mexico: { countryCode: "MX", phoneCode: "+52" },
  Micronesia: { countryCode: "FM", phoneCode: "+691" },
  Moldova: { countryCode: "MD", phoneCode: "+373" },
  Monaco: { countryCode: "MC", phoneCode: "+377" },
  Mongolia: { countryCode: "MN", phoneCode: "+976" },
  Montenegro: { countryCode: "ME", phoneCode: "+382" },
  Montserrat: { countryCode: "MS", phoneCode: "+1664" },
  Morocco: { countryCode: "MA", phoneCode: "+212" },
  Mozambique: { countryCode: "MZ", phoneCode: "+258" },
  Myanmar: { countryCode: "MM", phoneCode: "+95" },
  Namibia: { countryCode: "NA", phoneCode: "+264" },
  Nauru: { countryCode: "NR", phoneCode: "+674" },
  Nepal: { countryCode: "NP", phoneCode: "+977" },
  Netherlands: { countryCode: "NL", phoneCode: "+31" },
  "New Caledonia": { countryCode: "NC", phoneCode: "+687" },
  "New Zealand": { countryCode: "NZ", phoneCode: "+64" },
  Nicaragua: { countryCode: "NI", phoneCode: "+505" },
  Niger: { countryCode: "NE", phoneCode: "+227" },
  Nigeria: { countryCode: "NG", phoneCode: "+234" },
  Niue: { countryCode: "NU", phoneCode: "+683" },
  "Norfolk Island": { countryCode: "NF", phoneCode: "+672" },
  "North Korea": { countryCode: "KP", phoneCode: "+850" },
  "Northern Mariana Islands": { countryCode: "MP", phoneCode: "+1670" },
  Norway: { countryCode: "NO", phoneCode: "+47" },
  Oman: { countryCode: "OM", phoneCode: "+968" },
  Pakistan: { countryCode: "PK", phoneCode: "+92" },
  Palau: { countryCode: "PW", phoneCode: "+680" },
  Palestine: { countryCode: "PS", phoneCode: "+970" },
  Panama: { countryCode: "PA", phoneCode: "+507" },
  "Papua New Guinea": { countryCode: "PG", phoneCode: "+675" },
  Paraguay: { countryCode: "PY", phoneCode: "+595" },
  Peru: { countryCode: "PE", phoneCode: "+51" },
  Philippines: { countryCode: "PH", phoneCode: "+63" },
  "Pitcairn Islands": { countryCode: "PN", phoneCode: "+870" },
  Poland: { countryCode: "PL", phoneCode: "+48" },
  Portugal: { countryCode: "PT", phoneCode: "+351" },
  "Puerto Rico": { countryCode: "PR", phoneCode: "+1" },
  Qatar: { countryCode: "QA", phoneCode: "+974" },
  Reunion: { countryCode: "RE", phoneCode: "+262" },
  Romania: { countryCode: "RO", phoneCode: "+40" },
  Russia: { countryCode: "RU", phoneCode: "+7" },
  Rwanda: { countryCode: "RW", phoneCode: "+250" },
  "Saint Barthélemy": { countryCode: "BL", phoneCode: "+590" },
  "Saint Helena": { countryCode: "SH", phoneCode: "+290" },
  "Saint Kitts and Nevis": { countryCode: "KN", phoneCode: "+1869" },
  "Saint Lucia": { countryCode: "LC", phoneCode: "+1758" },
  "Saint Martin": { countryCode: "MF", phoneCode: "+590" },
  "Saint Pierre and Miquelon": { countryCode: "PM", phoneCode: "+508" },
  "Saint Vincent and the Grenadines": { countryCode: "VC", phoneCode: "+1784" },
  Samoa: { countryCode: "WS", phoneCode: "+685" },
  "San Marino": { countryCode: "SM", phoneCode: "+378" },
  "Sao Tome and Principe": { countryCode: "ST", phoneCode: "+239" },
  "Saudi Arabia": { countryCode: "SA", phoneCode: "+966" },
  Senegal: { countryCode: "SN", phoneCode: "+221" },
  Serbia: { countryCode: "RS", phoneCode: "+381" },
  Seychelles: { countryCode: "SC", phoneCode: "+248" },
  "Sierra Leone": { countryCode: "SL", phoneCode: "+232" },
  Singapore: { countryCode: "SG", phoneCode: "+65" },
  "Sint Maarten": { countryCode: "SX", phoneCode: "+1721" },
  Slovakia: { countryCode: "SK", phoneCode: "+421" },
  Slovenia: { countryCode: "SI", phoneCode: "+386" },
  "Solomon Islands": { countryCode: "SB", phoneCode: "+677" },
  Somalia: { countryCode: "SO", phoneCode: "+252" },
  "South Africa": { countryCode: "ZA", phoneCode: "+27" },
  "South Georgia and the South Sandwich Islands": {
    countryCode: "GS",
    phoneCode: "+500",
  },
  "South Korea": { countryCode: "KR", phoneCode: "+82" },
  "South Sudan": { countryCode: "SS", phoneCode: "+211" },
  Spain: { countryCode: "ES", phoneCode: "+34" },
  "Sri Lanka": { countryCode: "LK", phoneCode: "+94" },
  Sudan: { countryCode: "SD", phoneCode: "+249" },
  Suriname: { countryCode: "SR", phoneCode: "+597" },
  "Svalbard and Jan Mayen": { countryCode: "SJ", phoneCode: "+47" },
  Swaziland: { countryCode: "SZ", phoneCode: "+268" },
  Sweden: { countryCode: "SE", phoneCode: "+46" },
  Switzerland: { countryCode: "CH", phoneCode: "+41" },
  Syria: { countryCode: "SY", phoneCode: "+963" },
  Taiwan: { countryCode: "TW", phoneCode: "+886" },
  Tajikistan: { countryCode: "TJ", phoneCode: "+992" },
  Tanzania: { countryCode: "TZ", phoneCode: "+255" },
  Thailand: { countryCode: "TH", phoneCode: "+66" },
  "Timor-Leste": { countryCode: "TL", phoneCode: "+670" },
  Togo: { countryCode: "TG", phoneCode: "+228" },
  Tokelau: { countryCode: "TK", phoneCode: "+690" },
  Tonga: { countryCode: "TO", phoneCode: "+676" },
  "Trinidad and Tobago": { countryCode: "TT", phoneCode: "+1868" },
  Tunisia: { countryCode: "TN", phoneCode: "+216" },
  Turkey: { countryCode: "TR", phoneCode: "+90" },
  Turkmenistan: { countryCode: "TM", phoneCode: "+993" },
  Tuvalu: { countryCode: "TV", phoneCode: "+688" },
  Uganda: { countryCode: "UG", phoneCode: "+256" },
  Ukraine: { countryCode: "UA", phoneCode: "+380" },
  "United Arab Emirates": { countryCode: "AE", phoneCode: "+971" },
  "United Kingdom": { countryCode: "GB", phoneCode: "+44" },
  "United States": { countryCode: "US", phoneCode: "+1" },
  Uruguay: { countryCode: "UY", phoneCode: "+598" },
  Uzbekistan: { countryCode: "UZ", phoneCode: "+998" },
  Vanuatu: { countryCode: "VU", phoneCode: "+678" },
  "Vatican City": { countryCode: "VA", phoneCode: "+379" },
  Venezuela: { countryCode: "VE", phoneCode: "+58" },
  Vietnam: { countryCode: "VN", phoneCode: "+84" },
  "Wallis and Futuna": { countryCode: "WF", phoneCode: "+681" },
  "Western Sahara": { countryCode: "EH", phoneCode: "+212" },
  Yemen: { countryCode: "YE", phoneCode: "+967" },
  Zambia: { countryCode: "ZM", phoneCode: "+260" },
  Zimbabwe: { countryCode: "ZW", phoneCode: "+263" },
};
